import { clsx } from 'clsx';
import type { InputHTMLAttributes } from 'react';

export function Input({ className, ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={clsx(
        'h-10 w-full rounded-xl border border-border bg-white px-3 text-base text-brown',
        'placeholder:text-brown-lt focus:outline-none focus:ring-2 focus:ring-sage focus:border-sage',
        className,
      )}
      {...rest}
    />
  );
}
